/* Little Whiskers — hamper builder.
   One row per cookie (flavour dropdown + Regular / Monk fruit), "Randomize it for me",
   optional handwritten note (+ no-AI discount code), optional "send to someone else" address,
   then adds the hamper to the cart with line item properties. */
(function () {
  function toast(msg) { if (typeof lwToast === 'function') lwToast(msg); }

  // "400001-400107, 400601" → true if pin is inside any range (blank list = allow all)
  function pinAllowed(pin, list) {
    if (!list || !list.trim()) return true;
    var n = parseInt(pin, 10);
    return list.split(/[\s,;]+/).some(function (part) {
      if (!part) return false;
      var r = part.split('-');
      var a = parseInt(r[0], 10), b = parseInt(r[1] || r[0], 10);
      return !isNaN(a) && !isNaN(b) && n >= Math.min(a, b) && n <= Math.max(a, b);
    });
  }

  function initBuilder(card) {
    if (card.dataset.hbReady) return;
    card.dataset.hbReady = '1';

    var addBtn = card.querySelector('[data-add]');
    var status = card.querySelector('[data-status]');
    var useVersions = card.dataset.versions === '1';

    var noteToggle = card.querySelector('[data-note-toggle]');
    var noteBody = card.querySelector('[data-note-body]');
    var noteBox = card.querySelector('[data-note]');
    var noteCount = card.querySelector('[data-note-count]');
    var noAi = card.querySelector('[data-noai]');
    var giftToggle = card.querySelector('[data-gift-toggle]');
    var giftBody = card.querySelector('[data-gift-body]');

    var groups = Array.prototype.slice.call(card.querySelectorAll('.lw-hb-group')).map(function (el) {
      return {
        el: el,
        label: el.dataset.group,
        slots: Array.prototype.slice.call(el.querySelectorAll('[data-slot]')),
        countEl: el.querySelector('[data-count]')
      };
    });

    function slotValue(slot) {
      var flavour = slot.querySelector('[data-flavour]').value;
      if (!flavour) return '';
      if (!useVersions) return flavour;
      var v = slot.querySelector('.lw-hb-ver input:checked');
      return flavour + ' (' + (v ? v.value : 'Regular') + ')';
    }

    function remaining() {
      var left = [];
      groups.forEach(function (g) {
        var n = g.slots.filter(function (s) { return !s.querySelector('[data-flavour]').value; }).length;
        if (n) left.push(n + ' ' + g.label);
      });
      return left;
    }

    function render() {
      groups.forEach(function (g) {
        var filled = 0;
        g.slots.forEach(function (s) {
          var on = !!s.querySelector('[data-flavour]').value;
          s.classList.toggle('is-filled', on);
          if (on) { filled++; s.classList.remove('is-error'); }
        });
        if (g.countEl) g.countEl.textContent = filled;
        g.el.classList.toggle('is-complete', filled === g.slots.length);
      });
      if (status) {
        var left = remaining();
        status.textContent = left.length ? 'Still to choose: ' + left.join(' + ') : '';
      }
    }

    if (noteToggle) {
      noteToggle.addEventListener('change', function () {
        noteBody.hidden = !noteToggle.checked;
        if (noteToggle.checked) noteBox.focus();
      });
      noteBox.addEventListener('input', function () {
        noteCount.textContent = noteBox.value.length;
        noteBox.classList.remove('is-error');
      });
    }
    if (giftToggle) {
      giftToggle.addEventListener('change', function () {
        giftBody.hidden = !giftToggle.checked;
        if (giftToggle.checked) giftBody.querySelector('input').focus();
      });
      giftBody.addEventListener('input', function (e) {
        e.target.classList.remove('is-error');
        if (e.target.matches('[data-gift-pin]')) {
          var v = e.target.value.trim();
          var pinMsg = card.querySelector('[data-pin-msg]');
          if (!pinMsg) return;
          if (/^\d{6}$/.test(v) && !pinAllowed(v, card.dataset.pins)) {
            pinMsg.textContent = card.dataset.pinError || "Sorry, we don't deliver to this pincode yet.";
            pinMsg.hidden = false;
            e.target.classList.add('is-error');
          } else {
            pinMsg.hidden = true;
          }
        }
      });
    }

    card.addEventListener('change', function (e) {
      if (e.target.matches('[data-flavour]') || e.target.closest('.lw-hb-ver')) render();
    });

    card.addEventListener('click', function (e) {
      if (e.target.closest('[data-randomize]')) {
        groups.forEach(function (g) {
          g.slots.forEach(function (s) {
            var sel = s.querySelector('[data-flavour]');
            var n = sel.options.length - 1;
            if (n > 0) sel.selectedIndex = 1 + Math.floor(Math.random() * n);
          });
        });
        render();
        card.querySelectorAll('[data-slot]').forEach(function (s, i) {
          s.classList.remove('is-pop'); void s.offsetWidth;
          s.style.animationDelay = (i * 40) + 'ms';
          s.classList.add('is-pop');
        });
        return;
      }
      if (e.target.closest('[data-add]') && addBtn && !addBtn.disabled) addHamper();
    });

    function addHamper() {
      // 1. every cookie chosen?
      var firstEmpty = null;
      groups.forEach(function (g) {
        g.slots.forEach(function (s) {
          if (!s.querySelector('[data-flavour]').value) {
            s.classList.add('is-error');
            if (!firstEmpty) firstEmpty = s;
          }
        });
      });
      if (firstEmpty) {
        firstEmpty.scrollIntoView({ behavior: 'smooth', block: 'center' });
        firstEmpty.querySelector('select').focus({ preventScroll: true });
        toast('Choose a flavour for every cookie first, or tap 🎲 Randomize it for me.');
        return;
      }

      var props = {};
      groups.forEach(function (g) {
        var counts = {}; var order = [];
        g.slots.forEach(function (s) {
          var v = slotValue(s);
          if (!counts[v]) { counts[v] = 0; order.push(v); }
          counts[v]++;
        });
        props[g.label + ' cookies'] = order.map(function (v) { return v + ' × ' + counts[v]; }).join(', ');
      });

      // 2. note
      var noteCode = '';
      if (noteToggle && noteToggle.checked) {
        var noteText = noteBox.value.trim();
        if (!noteText) {
          noteBox.classList.add('is-error');
          noteBox.focus();
          toast('Write your note, or untick "Add a handwritten note".');
          return;
        }
        props['Handwritten note'] = noteText;
        if (noAi && noAi.checked && card.dataset.noteCode) {
          noteCode = card.dataset.noteCode;
          props['Written without AI'] = 'Yes';
          props['_note_code'] = noteCode;
        }
      }

      // 3. different address
      if (giftToggle && giftToggle.checked) {
        var gName = card.querySelector('[data-gift-name]');
        var gPhone = card.querySelector('[data-gift-phone]');
        var gAddr = card.querySelector('[data-gift-address]');
        var gPin = card.querySelector('[data-gift-pin]');
        var missing = null;
        [gName, gPhone, gAddr, gPin].forEach(function (f) {
          if (!f.value.trim()) { f.classList.add('is-error'); if (!missing) missing = f; }
        });
        if (gPin.value.trim() && !/^\d{6}$/.test(gPin.value.trim())) { gPin.classList.add('is-error'); if (!missing) missing = gPin; }
        if (!missing && !pinAllowed(gPin.value.trim(), card.dataset.pins)) {
          gPin.classList.add('is-error');
          var pinMsg = card.querySelector('[data-pin-msg]');
          if (pinMsg) { pinMsg.textContent = card.dataset.pinError || "Sorry, we don't deliver to this pincode yet."; pinMsg.hidden = false; }
          gPin.focus();
          toast(card.dataset.pinError || "Sorry, we don't deliver to this pincode yet.");
          return;
        }
        if (missing) {
          missing.focus();
          toast("Add the recipient's name, phone, address and 6-digit pincode, or untick \"Send this hamper to someone else\".");
          return;
        }
        props['Deliver to'] = gName.value.trim();
        props['Recipient phone'] = gPhone.value.trim();
        props['Delivery address'] = gAddr.value.trim().replace(/\s*\n\s*/g, ', ') + ' – ' + gPin.value.trim();
        if (card.dataset.feeVariant) props['_fee_variant'] = card.dataset.feeVariant;
      }

      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      if (typeof Sound !== 'undefined' && Sound.crunch) { try { Sound.crunch(); } catch (err) {} }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(card.dataset.variant, 10), quantity: 1, properties: props }] })
      })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (r) {
        addBtn.disabled = false;
        addBtn.textContent = 'Add to cart ♡';
        if (!r.ok) { toast(r.data.description || "Couldn't add that hamper. Please try again."); return; }

        // reset for the next hamper
        card.querySelectorAll('[data-flavour]').forEach(function (sel) { sel.selectedIndex = 0; });
        card.querySelectorAll('.lw-hb-ver').forEach(function (ver) {
          var first = ver.querySelector('input'); if (first) first.checked = true;
        });
        if (noteToggle) {
          noteToggle.checked = false; noteBody.hidden = true; noteBox.value = ''; noteCount.textContent = '0';
          if (noAi) noAi.checked = false;
        }
        if (giftToggle) {
          giftToggle.checked = false; giftBody.hidden = true;
          giftBody.querySelectorAll('input, textarea').forEach(function (f) { f.value = ''; });
        }
        render();

        var afterAdd = function () { if (typeof toggleCart === 'function') toggleCart(true); };
        if (noteCode) {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ discount: noteCode })
          }).catch(function () {}).then(afterAdd);
        } else {
          afterAdd();
        }
      })
      .catch(function () {
        addBtn.disabled = false;
        addBtn.textContent = 'Add to cart ♡';
        toast("Couldn't add that hamper. Please check your connection and try again.");
      });
    }

    render();
  }

  function initAll() { document.querySelectorAll('.lw-hb').forEach(initBuilder); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
